const nav = ["home", "about", "projects", "skills" , "contact"]; export default nav
